var template = require('../templates/index.html');
/**
 * directives.cardsList Module
 *
 * Description
 */
var app = angular.module('directives.cardsList');

app.directive('cardsList', ['$http', function($http) {
    // Runs during compile
    return {
        // name: '',
        // priority: 1,
        // terminal: true,
        // scope: {}, // {} = isolate, true = child, false/undefined = no change
        // controller: function($scope, $element, $attrs, $transclude) {},
        // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
        // restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        template: template,
        // templateUrl: '',
        replace: true,
        // transclude: true,
        // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
        link: function($scope, el, attrs, controller) {


        	$scope.cards = [
        		{
        			name: 'VISA Credit Card',
				    type: 'VISA',
				    number: '9483 **** 2231',
				    amount: 2810
				},
				{
        			name: 'VISA Credit Card',
				    type: 'VISA',
				    number: '9483 **** 2231',
				    amount: 2810
				},
				{
        			name: 'VISA Credit Card',
				    type: 'VISA',
				    number: '9483 **** 2231',
				    amount: 2810
				},
				{
        			name: 'VISA Credit Card',
				    type: 'VISA',
				    number: '9483 **** 2231',
				    amount: 2810
				},

        	];
        	

        }
    };
}]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/cardsList/directives/cards.directive.js
 ** module id = 145
 ** module chunks = 1
 **/